export default __webpack_public_path__ + "static/media/pinterest_mid_735x1500px.005b8b87.png";